import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {DAY_SECONDS} from '@npck/libs/commons';

@Pipe({
    name: 'uiKitTimerFormat',
    standalone: false
})
export class TimerFormatPipe implements PipeTransform {

    constructor(private translateService: TranslateService) {
    }

    transform(value: number, translationKey?: string): string {
        if (!value && value != 0) {
            return '';
        }
        const timer = this.getTimer(value);
        if (translationKey) {
            const translated = this.translateService.instant(translationKey, timer);
            if (translated !== translationKey) {
                return translated;
            }
        }
        return this.formatTimer(timer);
    }

    private getTimer(seconds: number): Timer {
        const days = Math.floor(seconds / DAY_SECONDS);
        const hours = Math.floor((seconds % DAY_SECONDS) / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const remainingSeconds = seconds % 60;
        return {
            days: days > 0 ? days.toString() : '0',
            hours: hours.toString().padStart(2, '0'),
            minutes: minutes.toString().padStart(2, '0'),
            seconds: remainingSeconds.toString().padStart(2, '0'),
        };
    }

    private formatTimer({days, hours, minutes, seconds}: Timer): string {
        const parts: string[] = [];
        days != '0' && parts.push(`${days}d`);
        hours != '00' && parts.push(`${hours}:`);
        parts.push(`${minutes}:`);
        parts.push(seconds);
        return parts.join('');
    }
}

interface Timer {
    days?: string;
    hours?: string;
    minutes: string;
    seconds: string;
}
